import { SubscriptionPlea } from '@/app_components/Article/embeds/SubscriptionPlea';
import { EmbedPriority, type ParserRule } from '@/app_lib/htmlParser/inserter/rules/types';
import type { Article } from '@/app_lib/types/Article';

export const embedSubscriptionPleaRule = ({
  enableSubscriptionPlea,
  subscriptionPleaTextLined,
}: Pick<Article['postSettings'], 'subscriptionPleaTextLined' | 'enableSubscriptionPlea'>): ParserRule => ({
  insertComponent: ({ index }) => (
    <SubscriptionPlea
      key={`subscription-plea ${index}`}
      subscriptionPleaTextLined={subscriptionPleaTextLined}
    />
  ),
  insertPosition: 'end',
  match: () => enableSubscriptionPlea,
  priority: EmbedPriority.Low,
});
